import React from "react";

export const EditorAddExercise = React.createContext<boolean>(false);

export function useAddExercise(): any {
  return React.useContext(EditorAddExercise);
}
